import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, Mail } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { ServiceCard } from "../components/ServiceCard";
import { SERVICE_KEYS, CONTACT_INFO } from "../lib/data";
import { buildQuoteMailto } from "../lib/mailto";

export default function Services() {
  const { t, lang } = useLang();
  return (
    <div data-testid="page-services">
      {/* Header */}
      <section className="bg-gradient-to-b from-slate-50 to-white py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl"
          >
            <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#0022FF] mb-4">
              <span className="h-px w-8 bg-[#0022FF]" />
              {t.nav.services}
            </div>
            <h1 className="font-display font-black text-slate-900 text-5xl sm:text-6xl lg:text-7xl tracking-tight">
              {t.services.title}
            </h1>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">{t.services.subtitle}</p>
          </motion.div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="pb-20 lg:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {SERVICE_KEYS.map((k, i) => (
              <ServiceCard key={k} slug={k} index={i} />
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 rounded-3xl bg-white border border-slate-200 p-8 lg:p-10">
            <div>
              <h3 className="font-display font-black text-2xl sm:text-3xl text-slate-900 tracking-tight">
                {t.home.ctaTitle}
              </h3>
              <p className="mt-2 text-slate-600">{t.home.ctaSubtitle}</p>
            </div>
            <div className="flex flex-wrap gap-3">
              <a
                href={buildQuoteMailto(lang)}
                data-testid="services-cta-consultation"
                className="inline-flex items-center gap-2 rounded-full btn-shk-primary px-6 py-3 text-sm font-semibold"
              >
                <Mail className="h-4 w-4" />
                {t.services.ctaQuote}
              </a>
              <a
                href={`tel:${CONTACT_INFO.phoneClean}`}
                data-testid="services-cta-call"
                className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-6 py-3 text-sm font-semibold text-slate-800 hover:border-[#0022FF] hover:text-[#0022FF]"
              >
                <Phone className="h-4 w-4" />
                {CONTACT_INFO.phone}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
